import { View, Text } from "../base";
import { Icon } from "../base/Icon";
import { JsonViewer } from "../base/JsonViewer";

export interface RawSpanData {
  input?: string;
  output?: string;
  attributes: Record<string, unknown>;
}

interface RawSpanDetailViewProps {
  data: RawSpanData;
  className?: string;
}

export const RawSpanDetailView = ({ data, className }: RawSpanDetailViewProps) => {
  return (
    <View className={`space-y-4 ${className || ""}`}>
      {/* Raw Input */}
      {data.input && (
        <View>
          <View className="flex flex-row items-center gap-2 mb-2">
            <Icon
              name="input"
              size={14}
              className="text-gray-500"
            />
            <Text className="text-sm font-medium text-gray-700 dark:text-gray-300">Input</Text>
          </View>
          <View className="bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
            <JsonViewer
              data={data.input}
              collapsed={10}
              className="p-2"
            />
          </View>
        </View>
      )}

      {/* Raw Output */}
      {data.output && (
        <View>
          <View className="flex flex-row items-center gap-2 mb-2">
            <Icon
              name="data-array"
              size={14}
              className="text-gray-500"
            />
            <Text className="text-sm font-medium text-gray-700 dark:text-gray-300">Output</Text>
          </View>
          <View className="bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
            <JsonViewer
              data={data.output}
              collapsed={10}
              className="p-2"
            />
          </View>
        </View>
      )}

      {/* Full Attributes */}
      <View>
        <View className="flex flex-row items-center gap-2 mb-2">
          <Icon
            name="code"
            size={14}
            className="text-gray-500"
          />
          <Text className="text-sm font-medium text-gray-700 dark:text-gray-300">All Attributes</Text>
        </View>
        <View className="bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
          <JsonViewer
            data={data.attributes}
            collapsed={10}
            className="p-2"
          />
        </View>
      </View>
    </View>
  );
};
